import * as Yup from 'yup'
import { Form, Row, Col } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormControl, CustomFormSelect } from '../../../../StyledComponents';
import { checkGrade } from '../ValidationRules';

export const Schema = Yup.object().shape({
    schoolEducation: Yup.string().required("Angabe ist erforderlich"),
    schoolGrade: checkGrade,
});

export const SchoolEducationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formSchoolEducation">
                <Form.Label>Abschluss*</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name="schoolEducation"
                    value={values.schoolEducation}
                    isValid={touched.schoolEducation && !errors.schoolEducation}
                    isInvalid={touched.schoolEducation && errors.schoolEducation}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.ScoolEducation.map((item, index) => <option key={index}>{item}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.schoolEducation}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formSchoolGrade">
                <Form.Label>Note</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Note"
                    type="number"
                    name="schoolGrade"
                    value={values.schoolGrade || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.schoolGrade && !errors.schoolGrade}
                    isInvalid={errors.schoolGrade}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.schoolGrade}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};